import React, { useState, useEffect } from 'react';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const appEl = document.querySelector('.App');
    if (!appEl) return;
    const handleScroll = () => setScrolled(appEl.scrollTop > window.innerHeight * 0.5);
    appEl.addEventListener('scroll', handleScroll, { passive: true });
    return () => appEl.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'header-scrolled' : ''}`}>
      <div className="header-bar">
        <a href="#home" className="header-id">southlabs.ai</a>
        <div className="header-divider" />
        <nav className="nav-links">
          <a href="#apps" className="nav-link"><span className="nav-slash">/</span>apps</a>
          <a href="#services" className="nav-link"><span className="nav-slash">/</span>services</a>
          <a href="#contact" className="nav-link"><span className="nav-slash">/</span>contact</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
